import { render, staticRenderFns } from "./NoteTextForm.vue?vue&type=template&id=e60a4f14&"
import script from "./NoteTextForm.vue?vue&type=script&lang=js&"
export * from "./NoteTextForm.vue?vue&type=script&lang=js&"
import style0 from "./NoteTextForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VForm,VTextarea})
